module.exports = __webpack_public_path__ + "static/media/checkmark_check_tick.7442d009.svg";